import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.parameters.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.parameters.actionsLoading;
export const getItems = (state:RootState) => state.parameters.items;
export const getItemsSelect = (state:RootState) => state.parameters.dropDownItems;
export const getItemsCount = (state:RootState) => state.parameters.itemsCount;
export const getItemForEdit = (state:RootState) => state.parameters.itemForEdit;
export const getError = (state:RootState) => state.parameters.error;
export const getErrorAction = (state:RootState) => state.parameters.errorAction;
export const validationErrors = (state: RootState) => state.parameters.validationErrors;
export const getFilters = (state: RootState) => state.parameters.filters;
